var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    fill: "#F0F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(5, 4)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86672 2.09314C5.58689 2.09314 5.36005 2.31999 5.36005 2.59981V4.17314H10.64V2.59981C10.64 2.31999 10.4132 2.09314 10.1334 2.09314H5.86672ZM11.76 4.17314V2.59981C11.76 1.70143 11.0318 0.973145 10.1334 0.973145H5.86672C4.96833 0.973145 4.24005 1.70143 4.24005 2.59981V4.17314H0.800049V5.29314H1.84005V15.3998C1.84005 16.2982 2.56833 17.0265 3.46672 17.0265H13.3334C13.4318 17.0265 14.16 16.2982 14.16 15.3998V5.29314H15.2V4.17314H11.76ZM13.04 5.29314H2.96005V15.3998C2.96005 15.6796 3.18689 15.9065 3.46672 15.9065H13.3334C12.8132 15.9065 13.04 15.6796 13.04 15.3998V5.29314ZM5.04005 13.7998V7.39981H6.16005V13.7998H5.04005ZM7.44005 13.7998V7.39981H8.56005V13.7998H7.44005ZM9.84005 13.7998V7.39981H10.96V13.7998H9.84005Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    stroke: "#DCE0E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinBlack);
export default __webpack_public_path__ + "static/media/bin-black.70127c779324cd632023f9ab90d57a3b.svg";
export { ForwardRef as ReactComponent };